import { Button, ButtonProps } from 'react-bootstrap';
import { COLOR_PRIMARY } from '../../theme/styles';
import styled from 'styled-components';
import { lighten } from 'polished';

const Icon = styled.div`
    display: flex;
    margin-right: 5px;
    pointer-events: none;
    background-color: transparent;
`

interface VbButtonProps extends ButtonProps {
    icon?: any;
    color?: any;
    iconcenter?: any;
    outlined?: any;
}

export const VbButton = (props: VbButtonProps) => {
    const _color = props.color ? props.color : COLOR_PRIMARY;

    return (
        <Button
            size={props.size ? props.size : 'sm'}
            {...props}
            style={{
                borderRadius: '4px',
                ...props.style,
                backgroundColor: props.outlined ? 'transparent' : _color,
                borderColor: _color,
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                color: props.outlined ? _color : '#fff',
            }}
            onFocus={(e: any) => {
                e.target.style.boxShadow = `0 0 0 0.05rem #74747480, 0 0 0 0.1rem #74747440`;
            }}
            onBlur={(e: any) => {
                e.target.style.boxShadow = 'none';
            }}
            onMouseDown={(e: any) => {
                e.target.style.backgroundColor = props.outlined ? 'transparent' : lighten(0.1, _color);
                e.target.style.borderColor = lighten(0.07, _color);
            }}
            onMouseUp={(e: any) => {
                e.target.style.backgroundColor = props.outlined ? 'transparent' : _color;
                e.target.style.borderColor = _color;
            }}
        >
            {props.icon &&
                <Icon> {props.icon} </Icon>
            }
            {props.iconcenter &&
                <Icon style={{ margin: 0 }}> {props.iconcenter} </Icon>
            }
            {props.children}
        </Button>
    )
}
